import React from "react";
import { LinkButton } from "../../../../elements/LinkButton";
import { styles } from "./ContentAfterRecordCheck.styles";

export interface IContentAfterRecordCheckProps {
  subtitle: string;
  afterVinCheck: string;
  vhrFound: string;
  isVinValid: boolean;
  onCtaClick: React.MouseEventHandler;
  ctaLink: string;
  ctaText: string;
  VinSearchComponent: React.ReactNode;
  ctaRef?: (node: HTMLDivElement | null) => void;
  secondaryCta?: React.ReactNode;
}

export const ContentAfterRecordCheck = ({
  subtitle,
  afterVinCheck,
  vhrFound,
  isVinValid,
  onCtaClick,
  ctaLink,
  ctaText,
  VinSearchComponent,
  ctaRef,
  secondaryCta,
}: IContentAfterRecordCheckProps) => {
  return (
    <div className={styles.wrapper()}>
      <div className={styles.vinMessage()} dangerouslySetInnerHTML={{ __html: subtitle }} />
      {isVinValid ? (
        <>
          <div className={styles.vhrFound()} dangerouslySetInnerHTML={{ __html: vhrFound }} />
          <div ref={ctaRef} data-testid="car-submission-button" className={styles.buttonWrapper()}>
            <LinkButton href={ctaLink} onClick={onCtaClick} className={styles.button()}>
              {ctaText}
            </LinkButton>
            {secondaryCta}
          </div>
        </>
      ) : (
        <>
          {VinSearchComponent}
          <div className={styles.vinMessage()} dangerouslySetInnerHTML={{ __html: afterVinCheck }} />
        </>
      )}
    </div>
  );
};
